import React, { useEffect, useState } from "react";
import { Switch } from "antd";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import {
  saveOpportunityAutoInviteExternalCandidates,
  SAVE_AUTO_INVITE_EXTERNAL_CANDIDATES
} from "../../../store/actions/opportunity";
import { isLoading } from "../../../utils/actions";
import Button from "../../../components/Button";
import * as gtag from "../../../lib/gtag";

function AutoInviteExternalCandidates({
  setAutoInviteExternalCandidates,
  enabled,
  onChange,
  opportunity,
  isDisabled = false,
  saveOpportunityAutoInviteExternalCandidates,
  savingOpportunity,
  setForm,
  newOpportunity
}) {
  const { t } = useTranslation(["opportunity"]);
  const [check, setCheck] = useState();

  useEffect(() => {
    setForm && !newOpportunity && setForm(check);
  }, [check, newOpportunity, setForm]);

  const handleSave = () => {
    gtag.event({
      category: "VacancyDetail",
      action: "VacancyDetail.Invite-Save",
      label: opportunity.id
    });
    saveOpportunityAutoInviteExternalCandidates(
      Boolean(opportunity.autoInviteExternalCandidates) // Boolean is to default undefined to false
    );
  };

  const isWizard = !opportunity;

  return (
    <div>
      <h2>{t("opportunity:publishing.autoInviteExternalCandidates.title")}</h2>
      <div style={{ display: "flex" }}>
        <Switch
          disabled={isDisabled}
          checked={
            isWizard
              ? enabled
              : Boolean(opportunity.autoInviteExternalCandidates)
          }
          onChange={checked => {
            !newOpportunity &&
              setCheck({ autoInviteExternalCandidates: checked });
            if (!isWizard) {
              setAutoInviteExternalCandidates(checked);
            }
            if (typeof onChange === "function") {
              onChange(checked);
            }
          }}
          style={{ marginRight: 12 }}
        />
        <p style={{ maxWidth: 670 }}>
          {t("opportunity:publishing.autoInviteExternalCandidates.description")}
        </p>
      </div>
      {opportunity && newOpportunity && (
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
        >
          <Button
            loading={savingOpportunity}
            disabled={isDisabled}
            type="primary"
            size="lg"
            onClick={handleSave}
            htmlType="submit"
          >
            {t("global:save")}
          </Button>
        </div>
      )}
    </div>
  );
}

export default connect(
  state => ({
    newOpportunity: state.opportunity.newOpportunity,
    savingOpportunity: isLoading(SAVE_AUTO_INVITE_EXTERNAL_CANDIDATES, state)
  }),
  {
    saveOpportunityAutoInviteExternalCandidates,
    setAutoInviteExternalCandidates: SAVE_AUTO_INVITE_EXTERNAL_CANDIDATES.run
  }
)(AutoInviteExternalCandidates);
